import React, { useState, useEffect, useRef, forwardRef } from "react";
import { createPortal } from 'react-dom';
import styles from './Select.module.less';
import setRef from '../../setRef';
export const Select = forwardRef(function ({ options, value, onChange, tabindex = 0 }, ref) {
    const [selected, setSelected] = useState();
    const [shown, show] = useState(false);
    const [pos, setPos] = useState({ x: 0, y: 0, width: 0 });
    const buttonEl = useRef(null);
    useEffect(() => {
        if (options.length) {
            setSelected(value ? options.find(option => option.value == value) : options[0]);
        }
    }, [options, value]);
    useEffect(() => {
        if (shown && buttonEl.current) {
            const { x, bottom: y, width } = buttonEl.current.getBoundingClientRect();
            setPos({ x, y, width });
        }
    }, [shown]);
    const onkey = (e) => {
        switch (e.key) {
            case 'Space':
            case 'Enter':
            case 'ArrowUp':
            case 'ArrowDown':
                show(true);
                e.preventDefault();
                e.stopPropagation();
                break;
            case 'Escape':
                show(false);
                e.preventDefault();
                e.stopPropagation();
                break;
        }
    };
    const onSelect = (option) => {
        setSelected(option);
        onChange(option.value);
        show(false);
    };
    return React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", ref: setRef(buttonEl, ref), tabIndex: tabindex, className: styles.button, onKeyDown: e => onkey(e), onClick: () => show(shown => !shown), onBlur: () => show(false) },
            React.createElement("span", null, selected?.label),
            React.createElement("svg", { height: "24", width: "24", viewBox: "0 -960 960 960" },
                React.createElement("path", { d: "M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z" }))),
        shown && createPortal(React.createElement("ul", { className: styles.options, style: { left: pos.x, top: pos.y, width: pos.width } }, options.map(option => React.createElement("li", { key: option.value, className: option.value == selected?.value ? styles.active : '', onMouseDown: e => { e.preventDefault(); onSelect(option); } }, option.label))), document.body));
});
